import { render, staticRenderFns } from "./DetailUserView.vue?vue&type=template&id=bd980c52&scoped=true&"
import script from "./DetailUserView.vue?vue&type=script&lang=js&"
export * from "./DetailUserView.vue?vue&type=script&lang=js&"
import style0 from "./DetailUserView.vue?vue&type=style&index=0&id=bd980c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd980c52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VDivider,VIcon,VSimpleTable})
